import { __assign } from "tslib";
import get from 'lodash/get';
var folderAdapter = function (props) {
    var price = get(props, 'folder.premiumFolderData.pointsPrice');
    var dollarsCost = get(props, 'folder.premiumFolderData.dollarPrice');
    return __assign(__assign({}, props), { price: price,
        dollarsCost: dollarsCost });
};
export default folderAdapter;
//# sourceMappingURL=folder.js.map